function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3688",
  "data-name": "Grupo 3688",
  transform: "translate(0 6.234)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7962",
  d: "M390.928 735.948h-20.376a2.233 2.233 0 0 1 0-4.466h20.376a15.252 15.252 0 0 0 0-30.5H376.37a2.233 2.233 0 0 1 0-4.466h14.558a19.718 19.718 0 0 1 0 39.435z",
  className: "cls-1",
  "data-name": "Caminho 7962",
  transform: "translate(-368.319 -696.513)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3689",
  "data-name": "Grupo 3689",
  transform: "translate(1.674)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7963",
  d: "M378.657 711.14a2.229 2.229 0 0 1-1.587-.663l-6.424-6.5a2.232 2.232 0 0 1 .02-3.157l6.5-6.423a2.232 2.232 0 1 1 3.139 3.175l-4.912 4.856 4.854 4.912a2.234 2.234 0 0 1-1.59 3.8z",
  className: "cls-1",
  "data-name": "Caminho 7963",
  transform: "translate(-370.002 -693.749)"
}));

var SvgReturn = function SvgReturn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3693",
    width: 42.326,
    height: 45.67,
    "data-name": "Grupo 3693",
    viewBox: "0 0 42.326 45.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/return.5a2f7137.svg";
export { ForwardRef as ReactComponent };